export enum ProfileSetupStepType {
  BankAccount = 'BankAccount',
  DriversLicense = 'DriversLicense',
  ProfessionalLicense = 'ProfessionalLicense',
  I9Form = 'I9Form',
  CprCertification = 'CprCertification',
  BackgroundCheck = 'BackgroundCheck',
  ImmunizationRecords = 'ImmunizationRecords',
  BlsCertification = 'BlsCertification'
}
